module.exports = __webpack_public_path__ + "img/map3_l.de94b5fd.jpg";